import {
  Button,
  Checkbox,
  Classes,
  Dialog,
  FormGroup,
  Icon,
  InputGroup,
  Spinner,
  Switch,
  Tab,
  Tabs,
} from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { api_adm } from "../../api";
import { newIProdutoPage, IProdutoPage } from "../../model";
import { toast } from "react-toastify";
import { MDBCol, MDBRow } from "mdbreact";
import { DateInput } from "@blueprintjs/datetime";
import { getMomentFormatter } from "../../utils";
import MomentLocaleUtils from "react-day-picker/moment";
const InputMask = require("react-input-mask");

interface ProdutoDialogCreateProps {
  onClose: () => void;
  estado: string;
}

interface ProdutoDialogCreateState {
}

@observer
export class ProdutoDialogCreate
  extends React.Component<ProdutoDialogCreateProps, ProdutoDialogCreateState> {
  obs = observable({
    produto: newIProdutoPage() as IProdutoPage,
    open_select_segments: false as boolean
  })

  async componentDidMount() {
  }

  renderNoData() {
    return (
      <div>
        Aguarde... &nbsp; &nbsp; &nbsp;

        <div className="spinner-border" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }

  /**
  * Salva (cria) um novo produto no contexto do estado atual via API administrativa.
  *
  * A função:
  * - Define `estado` no objeto `produto` com base em `this.props.estado`.
  * - Envia uma requisição **POST** para `/api/admin/produtos` com os dados do produto (`this.obs.produto`).
  * - Se a resposta contiver `{ ok: true }`:
  *   - Exibe um `toast.success` confirmando a criação.
  *   - Recarrega a página com `window.location.reload()`.
  * - Caso contrário:
  *   - Exibe um `toast.error` com a mensagem de erro da API (`resp.data.msg`).
  * - Em caso de exceção (erro de rede ou falha inesperada):
  *   - Exibe um `toast.error` genérico.
  *
  * @async
  * @returns {Promise<void>} Promise resolvida após a tentativa de criação do produto.
  */

  handleSave = async () => {

    const { descricao, ncm } = this.obs.produto;

    if (descricao === "") {
      toast.error("Descrição não pode ser vazia");
      return;
    }

    if (ncm === "") {
      toast.error("NCM não pode ser vazio");
      return;
    }

    try {
      this.obs.produto.estado = this.props.estado
      let resp = await api_adm.post("/api/admin/produtos", this.obs.produto);
      if (resp.data.ok) {
        toast.success('Produto criado', {});
        window.location.reload();
      } else {
        toast.error(`Produto não criado: ${resp.data.msg}`, {});
      }
    } catch (ex) {
      toast.error('Erro ao criar Produto"', {});
    }
  };

  renderData() {
    let dayPickerProps = {
          localeUtils: MomentLocaleUtils,
          locale: "pt-br",
        };
    return (
      <div>
        <FormGroup
          label="Descrição"
          labelFor="descricao"
        >
          <InputGroup
            id="descricao"
            style={{ width: 400 }}
            onChange={(e: any) => this.obs.produto.descricao = e.target.value}
          />
        </FormGroup>

        <FormGroup
          label="NCM (separador por vírgula e com ponto)"
          labelFor="ncm"
        >
          <InputGroup
            id="ncm"
            style={{ width: 200 }}
            onChange={(e: any) => this.obs.produto.ncm = e.target.value}
          />
        </FormGroup>

        <FormGroup
          label="CEST"
          labelFor="cest"
        >
          <InputMask
            id="cest"
            mask="99.999.99"
            className="form-control"
            onChange={(e: any) => this.obs.produto.cest = e.target.value}
          />
        </FormGroup>

        <FormGroup
          label="Validade"
          labelFor="validade"
        >
          <div style={{ width: 600, display: "flex", alignItems: "center" }}>
            <DateInput
              {...getMomentFormatter("DD/MM/YYYY")}
              locale="pt-br"
              dayPickerProps={dayPickerProps}
              value={this.obs.produto.valido_de ? new Date(this.obs.produto.valido_de) : null}
              onChange={val =>
                this.obs.produto.valido_de = val}
              placeholder="DD/MM/AAAA"
              canClearSelection
            />
            <Icon icon="arrow-right" style={{ margin: "0 10px" }} />
            <DateInput
              {...getMomentFormatter("DD/MM/YYYY")}
              locale="pt-br"
              dayPickerProps={dayPickerProps}
              value={this.obs.produto.valido_ate
                ? new Date(this.obs.produto.valido_ate)
                : null}
              onChange={val =>
                this.obs.produto.valido_ate = val}
              placeholder="DD/MM/AAAA"
              canClearSelection
            />
          </div>
        </FormGroup>

        <Switch
          checked={this.obs.produto.entrada}
          onChange={(e: any) => this.obs.produto.entrada = e.target.checked}
          innerLabelChecked="Entrada" innerLabel="Saída"
          style={{ marginTop: 12, marginLeft: "auto", fontSize: 12, fontWeight: 600 }}
        />

        <MDBRow>
          <MDBCol>
            <span><b style={{ cursor: "pointer", textDecoration: "underline" }} onClick={() => this.obs.open_select_segments = true}>{"Selecione os Segmentos"}</b></span>
          </MDBCol>
        </MDBRow>
      </div>
    );
  }

  render() {

    let title = "Detalhes";
    
    if (this.obs.produto) {
      title = this.obs.produto.descricao.substring(0, 100);
    }

    return (
      <>
        <Dialog
          isOpen={true}
          title={title}
          onClose={this.props.onClose}
          style={{ width: 800, height: 600 }}
        >
          <div className={Classes.DIALOG_BODY}>
            {this.renderData() || this.renderNoData()}
          </div>
          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Cancelar" onClick={this.props.onClose} />
              <Button text="Salvar" intent="primary" onClick={this.handleSave} />
            </div>
          </div>
        </Dialog>

        <Dialog
          isOpen={this.obs.open_select_segments}
          onClose={() => this.obs.open_select_segments = false}
          style={{ width: 600, height: 400 }}
        >
          <div className={Classes.DIALOG_BODY}>
            <FormGroup
              label="Selecione os segmentos:"
              labelFor="segmentos"
              >
              <div style ={{overflow: "auto", maxHeight: 400}}>
                <Checkbox
                  label={"Autopeças"}
                  checked={this.obs.produto.seg_auto_pecas}
                  onChange={(event: any) => this.obs.produto.seg_auto_pecas = event.target.checked}
                />
                <Checkbox
                  label={"Veterinário/pet"}
                  checked={this.obs.produto.seg_vet_pet}
                  onChange={(event: any) => this.obs.produto.seg_vet_pet = event.target.checked}
                />
                <Checkbox
                  label={"Refrigerantes"}
                  checked={this.obs.produto.seg_refrigerantes}
                  onChange={(event: any) => this.obs.produto.seg_refrigerantes = event.target.checked}
                />
                <Checkbox
                  label={"Aguas e outras bebidas"}
                  checked={this.obs.produto.seg_agua_out}
                  onChange={(event: any) => this.obs.produto.seg_agua_out = event.target.checked}
                />
                <Checkbox
                  label={"Lâmpadas, reatores e starter"}
                  checked={this.obs.produto.seg_lamp_reatores}
                  onChange={(event: any) => this.obs.produto.seg_lamp_reatores = event.target.checked}
                />
                <Checkbox
                  label={"Materiais de limpeza"}
                  checked={this.obs.produto.seg_mat_limpeza}
                  onChange={(event: any) => this.obs.produto.seg_mat_limpeza = event.target.checked}
                />
                <Checkbox
                  label={"Pneumáticos, câmaras de ar e protetores de borracha"}
                  checked={this.obs.produto.seg_pneumaticos_prot}
                  onChange={(event: any) => this.obs.produto.seg_pneumaticos_prot = event.target.checked}
                />
                <Checkbox
                  label={"Produtos alimentícios"}
                  checked={this.obs.produto.seg_alimenticios}
                  onChange={(event: any) => this.obs.produto.seg_alimenticios = event.target.checked}
                />
                <Checkbox
                  label={"Produtos de perfumaria e de higiene pessoal e cosméticos"}
                  checked={this.obs.produto.seg_perf_cosm}
                  onChange={(event: any) => this.obs.produto.seg_perf_cosm = event.target.checked}
                />
                <Checkbox
                  label={"Produtos eletrônicos, eletroeletrônicos e eletrodomésticos"}
                  checked={this.obs.produto.seg_eletro}
                  onChange={(event: any) => this.obs.produto.seg_eletro = event.target.checked}
                />
                <Checkbox
                  label={"Rações para animais domésticos"}
                  checked={this.obs.produto.seg_racoes}
                  onChange={(event: any) => this.obs.produto.seg_racoes = event.target.checked}
                />
                <Checkbox
                  label={"Sorvetes e preparados para fabricação de sorvetes em máquinas"}
                  checked={this.obs.produto.seg_sorvetes_fab}
                  onChange={(event: any) => this.obs.produto.seg_sorvetes_fab = event.target.checked}
                />
                <Checkbox
                  label={"Tintas e vernizes"}
                  checked={this.obs.produto.seg_tintas}
                  onChange={(event: any) => this.obs.produto.seg_tintas = event.target.checked}
                />
                <Checkbox
                  label={"Material de construção"}
                  checked={this.obs.produto.seg_mat_construcao}
                  onChange={(event: any) => this.obs.produto.seg_mat_construcao = event.target.checked}
                />
                <Checkbox
                  label={"Veículos automotores novos"}
                  checked={this.obs.produto.seg_veiculos_automotores}
                  onChange={(event: any) => this.obs.produto.seg_veiculos_automotores = event.target.checked}
                />
                <Checkbox
                  label={"Veículos novos de duas e três rodas motorizados"}
                  checked={this.obs.produto.seg_veiculos_novos}
                  onChange={(event: any) => this.obs.produto.seg_veiculos_novos = event.target.checked}
                />
                <Checkbox
                  label={"Medicamentos de uso humano e outros produtos farmacêuticos"}
                  checked={this.obs.produto.seg_medicamentos_humano}
                  onChange={(event: any) => this.obs.produto.seg_medicamentos_humano = event.target.checked}
                />
              </div>
            </FormGroup>
          </div>
          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Cancelar" onClick={() => this.obs.open_select_segments = false} />
              <Button
                text="Salvar"
                intent="primary"
                onClick={() => {
                  this.obs.open_select_segments = false;
                }}
              />
            </div>
          </div>
        </Dialog>
      </>
      
    );
  }
}
